let common = {

}

let production = {
  ...common,
  strapiBase: 'https://strapi.arlingtonva.us'
}

let staging = {
  ...common,
  strapiBase: 'https://stg-strapi.arlingtonva.us'
}

let exp

switch(process.env.NODE_ENV) {
  case 'production':
    exp = production;
    break;
  case 'staging':
    exp = staging;
    break;
  default:
    exp = staging;
}

module.exports = exp